import { SvgIcon, type SxProps, type Theme } from '@mui/material';

interface AddEquipmentIconProps {
  sx?: SxProps<Theme> | undefined;
}
const AddEquipmentIcon: React.FC<AddEquipmentIconProps> = ({ sx }) => (
  <SvgIcon sx={sx}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      zoomAndPan="magnify"
      viewBox="0 0 30 30.000001"
      height="28"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="acc614d7ef">
          <path
            d="M 18.742188 9.347656 L 28.902344 9.347656 L 28.902344 19.507812 L 18.742188 19.507812 Z M 18.742188 9.347656 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="255b9a5a6b">
          <path d="M 2 3 L 23 3 L 23 27 L 2 27 Z M 2 3 " clipRule="nonzero" />
        </clipPath>
        <clipPath id="377d9f2e32">
          <path
            d="M 3.414062 1.453125 L 25.621094 5.0625 L 22.007812 27.273438 L -0.199219 23.660156 Z M 3.414062 1.453125 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="3e66f332c5">
          <path
            d="M 25.878906 5.105469 L 3.671875 1.492188 L 0.0585938 23.703125 L 22.265625 27.3125 Z M 25.878906 5.105469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="af1835edd9">
          <path
            d="M 25.878906 5.105469 L 3.671875 1.492188 L 0.0585938 23.703125 L 22.265625 27.3125 Z M 25.878906 5.105469 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#acc614d7ef)">
        <path
          fill="rgba(0, 0, 0, 0.54)"
          d="M 25.398438 13.027344 C 25.300781 13.027344 25.222656 12.949219 25.222656 12.851562 C 25.222656 12.851562 25.222656 9.875 25.222656 9.875 C 25.222656 9.585938 24.988281 9.351562 24.699219 9.351562 L 22.945312 9.351562 C 22.65625 9.351562 22.421875 9.585938 22.421875 9.875 L 22.421875 12.851562 C 22.421875 12.949219 22.34375 13.027344 22.246094 13.027344 C 22.246094 13.027344 19.273438 13.027344 19.273438 13.027344 C 18.980469 13.027344 18.746094 13.261719 18.746094 13.550781 L 18.746094 15.304688 C 18.746094 15.59375 18.980469 15.828125 19.273438 15.828125 L 22.246094 15.828125 C 22.34375 15.828125 22.421875 15.90625 22.421875 16.003906 C 22.421875 16.003906 22.421875 18.976562 22.421875 18.976562 C 22.421875 19.269531 22.65625 19.503906 22.945312 19.503906 L 24.699219 19.503906 C 24.988281 19.503906 25.222656 19.269531 25.222656 18.976562 L 25.222656 16.003906 C 25.222656 15.90625 25.300781 15.828125 25.398438 15.828125 C 25.398438 15.828125 28.375 15.828125 28.375 15.828125 C 28.664062 15.828125 28.898438 15.59375 28.898438 15.304688 L 28.898438 13.550781 C 28.898438 13.261719 28.664062 13.027344 28.375 13.027344 Z M 25.398438 13.027344 "
          fillOpacity="1"
          fillRule="evenodd"
        />
      </g>
      <g clipPath="url(#255b9a5a6b)">
        <g clipPath="url(#377d9f2e32)">
          <g clipPath="url(#3e66f332c5)">
            <g clipPath="url(#af1835edd9)">
              <path
                fill="rgba(0, 0, 0, 0.54)"
                d="M 12.730469 10.433594 L 13.199219 10.097656 L 13.292969 9.535156 C 13.292969 9.535156 13.046875 9.191406 12.78125 8.765625 L 12.765625 8.742188 C 12.554688 8.449219 12.480469 8.078125 12.5625 7.726562 C 12.640625 7.375 12.871094 7.074219 13.1875 6.902344 L 13.199219 6.894531 C 14.890625 5.886719 16.207031 5.59375 17.253906 5.898438 C 17.253906 5.898438 17.367188 5.507812 17.367188 5.507812 L 17.761719 5.421875 C 17.753906 5.386719 17.734375 5.277344 17.605469 5.183594 C 16.027344 4.039062 14.816406 3.308594 13.488281 3.332031 C 12.589844 3.347656 11.621094 3.703125 10.449219 4.546875 C 7.992188 6.320312 5.53125 8.089844 5.53125 8.089844 L 5.386719 8.285156 L 4.957031 9.511719 L 3.242188 9.792969 L 3.070312 9.863281 L 2.25 10.453125 L 2.160156 11.015625 L 5.257812 15.320312 L 5.820312 15.410156 L 6.640625 14.820312 L 6.761719 14.679688 L 7.570312 13.140625 L 8.871094 13.125 L 9.101562 13.050781 L 9.617188 12.675781 L 19.171875 25.941406 C 19.789062 26.800781 20.988281 26.996094 21.847656 26.375 C 22.261719 26.078125 22.539062 25.628906 22.621094 25.128906 C 22.703125 24.625 22.582031 24.109375 22.285156 23.695312 Z M 12.730469 10.433594 "
                fillOpacity="1"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default AddEquipmentIcon;
